
import React from "react";
import { Classname } from "@rivtn/noseur";
import Btn from "../common/Btn";
import Highlight from "../common/Highlight";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { ITeamWebsite } from "../../../../../services";

export interface PartnersSectionProps {
    website: ITeamWebsite;
}

function PartnersSection({ website }: PartnersSectionProps) {

    const labels = i18nManager.Labels.home;
    const [social, username] = Object.entries(website.social_accounts ?? {})[0] ?? [];
    const name = website.team.name;

    return (<section className={styles["partners"]}>
        <div className={Classname.build(styles["container"], styles["partners-grid"])}>
            <div className={styles["partners-head"]}>
                <span className={styles["subtitle"]}>{labels.we_love}</span>
                <h2 className={styles["jumbo"]}><Highlight text={labels.our_partners} /></h2>
                <p className={styles["lead"]}>{labels.partners_text.replace(":name", name)}</p>
                {social && (<div className={styles["partners-invite"]}>
                    <h3>{labels.become_partner.replace(":name", name)}</h3>
                    <Btn href={Utils.getSocialLink(social, username)} target="_blank">{labels.get_in_touch}</Btn>
                </div>)}
            </div>
            <div className={styles["partners-logos"]}>
                {website.sponsors.map((s) => (<div key={s} className={styles["partners-logo"]}><img src={s} alt="" loading="lazy" /></div>))}
            </div>
        </div>
    </section>);
}

export default PartnersSection;
